

export const DELETE_POST = `
mutation deletePost ($postID: ID!){
    deletePost(id:$postID)
  }
`;
